import { ICommonFilterModel, IPatchModel } from 'shared/models/Common'

export interface IMessageRecipient {
  email: string
  name: string
  recipientType: RecipientTypeEnum
  nameregisterId: string
  phonenumber?: string
  isSent?: boolean
  unitIds?: string[]
}

export enum RecipientTypeEnum {
  To = 'To',
  From = 'From',
  Cc = 'Cc',
  Bcc = 'Bcc',
}

export interface ILabelModel {
  id: string
  path: string
  colorCodeId?: string
}

export interface IMessageUserModel {
  email: string
  name?: string
  nameId: string
}

export interface IInboxCase {
  id: string
  deadline: Date | null
  name: string
}

export interface IInboxPatchSingle {
  id: string
  patchModel: IPatchModel[]
}

export interface IInboxPatchModel {
  model: IInboxPatchSingle[]
}

export enum InboxSectionEnum {
  Processed = 'processed',
  Deleted = 'deleted',
  Sent = 'sent',
  Draft = 'draft',
  Received = 'received',
  Junk = 'junk',
  All = 'all',
}

export enum MessageState {
  Processed = 'Processed',
  Deleted = 'Deleted',
  PermanentlyDeleted = 'PermanentlyDeleted',
  Sent = 'Sent',
  Draft = 'Draft',
  Received = 'Received',
}

export enum InboxActionEnum {
  Edit = 'edit',
  Reply = 'reply',
  ReplyAll = 'replyAll',
  Forward = 'forward',
  MarkAsUnread = 'markAsUnread',
  AddLabel = 'addLabel',
  ConnectCase = 'connectCase',
  AssignEmail = 'assignEmail',
  Print = 'print',
  Delete = 'delete',
  HandledBy = 'handledBy',
  RemoveHandledBy = 'RemoveHandledBy',
  Restore = 'restore',
  SeenBy = 'seenBy',
  MoveToInbox = 'moveToInbox',
}

export enum InboxDeleteStatus {
  isDeleting = 'isDeleting',
  success = 'success',
  error = 'error',
}

export interface IDatesQueryModel {
  received: IPeriodQueryModel
  sent: IPeriodQueryModel
  deleted: IPeriodQueryModel
  processed: IPeriodQueryModel
}

export interface IPeriodQueryModel {
  from?: Date
  to?: Date
}

export interface IInboxFilters extends ICommonFilterModel {
  queryStatus: InboxSectionEnum
  labelId: string
  dates: IDatesQueryModel

  // Specific for email
  onlyUnread?: boolean
}

export type MessageTypes = 'sms' | 'email'
